import { Ticket, Download, RotateCcw } from "lucide-react";

export const DeviceCard = ({ device, subscriber, onCreateTicket }) => (
  <div className="device-card" data-testid={`device-card-${device.id}`}>
    <div className="device-image">
      <div className="device-image-placeholder">
        <div className="glow-dot"></div>
      </div>
    </div>
    <div className="device-info">
      <div className="device-info-row">
        <h3 className="device-id">{device.id}</h3>
        <span className="device-type">{device.type}:</span>
        <span className="device-status-badge">{device.status}</span>
        <span className="readiness-label">Original:</span>
        <span className={`readiness-badge ${device.originalReadiness.toLowerCase().replace(' ', '-')}`}>
          {device.originalReadiness}
        </span>
      </div>
      <div className="device-info-row">
        <span className="device-location">{device.location}</span>
        <span className="device-separator">&bull;</span>
        <span className="device-model">{device.model}</span>
      </div>
      <div className="device-info-row">
        <Download size={14} className="device-action-icon" />
        <RotateCcw size={14} className="device-action-icon" />
        <span className="aed-in-image-compact">
          <span className="aed-indicator"></span>
          AED: {device.aedInImage ? 'Yes' : '-'}
        </span>
        <span className="device-last-seen-compact">
          Not seen for {device.lastSeen} (last: {device.lastSeenDate})
        </span>
      </div>
    </div>
    <button 
      className="create-ticket-btn" 
      data-testid={`create-ticket-btn-${device.id}`}
      onClick={() => onCreateTicket(device)}
    >
      <Ticket size={16} />
      Create Ticket
    </button>
  </div>
);
